export default __webpack_public_path__ + "620ef4b282b105ea61b56ff44815c648.png";